<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img [src]="bucketurl + '/images/motorbike.png'" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="container-fluid pl-0">
  <div class="container-inner">
    <div [hidden]="isCreate || isEdit">
      <div class="header-container">
        <h2>Sales Lost Reason</h2>
          <div class="search-container">
          <input
            type="text"
            [formControl]="searchInput"
            placeholder="Search..."
            (input)="applyFilter()"
            class="form-control"
          />
          <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
        </div>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="add()">Add Sales Lost Reason</button>
        </div>
      </div>
      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>

          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Lost Reason</th>
            <td mat-cell *matCellDef="let element">{{element.reason}}</td>
          </ng-container>

          <ng-container matColumnDef="reason_code">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Reason code</th>
            <td mat-cell *matCellDef="let element">{{element.reason_code}}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="editData(element)">
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center;padding: 20px 0;" colspan="4">No data found!
            </td>
          </tr>
        </table>

        <mat-paginator #paginatorRef [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <ng-container *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>Sales Lost Reason</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to List</button>
        </div>
      </div>
      <form [formGroup]="salesReasonForm">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <div class="themeinput">
              <label>Sales Lost Reason </label><span style="color: red; font-size :15px">&nbsp;*</span>
              <input type="text" class="form-control" placeholder="Sales Lost Reason" formControlName="reason"
                (keypress)="allowAlphabetsSplcharsOnly($event)" maxlength="150"
                [ngClass]="{ 'is-invalid': submitted && f['reason'].errors }" />
              <div *ngIf="submitted && f['reason'].errors" class="invalid-feedback">
                <div *ngIf="f['reason'].errors['required']">
                  Sales Lost Reason is required
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <div class="themeinput">
              <label>Reason Code</label><span style="color: red; font-size :15px">&nbsp;*</span>
              <input type="text" class="form-control" placeholder="Reason Code" formControlName="reason_code"
               maxlength="30"
                [ngClass]="{ 'is-invalid': submitted && f['reason_code'].errors }" />
              <div *ngIf="submitted && f['reason_code'].errors" class="invalid-feedback">
                <div *ngIf="f['reason_code'].errors['required']">
                  Reason Code is required
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 mt-2">
            <div class="themeinput">
              <label>Status</label><span style="color: red; font-size :15px">&nbsp;*</span>
              <select name="" class="form-select" formControlName="status"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <option value="" disabled selected>--Select Status--</option>
                <option value="1">Active</option>
                <option value="0">In-Active</option>
              </select>
              <div *ngIf="submitted && f['status'].errors" class="invalid-feedback">
                <div *ngIf="f['status'].errors['required']">Status is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <div class="text-right-right">
              <button *ngIf="isCreate" mat-raised-button class="clear-button" (click)="clearForm()">Clear</button>
              <button *ngIf="isCreate" class="create-button ml-2" mat-raised-button (click)="create()">Create</button>
              <button *ngIf="isEdit" class="create-button ml-2" mat-raised-button (click)="update()">Update</button>
            </div>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>